import React, { useState } from 'react';


const CategoryList = ({ onSelectCategory, categories }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    const category = categories.find(cat => cat.id === parseInt(selectedId));
    setSelectedCategory(category);
    onSelectCategory(category);
  };

  return (
    <div className="mb-5">
      <select
        className="bg-gray-800 text-white p-2.5 rounded-md w-full"
        value={selectedCategory?.id || ''}
        onChange={handleChange}
      >
        <option value="" disabled>Select a category</option>
        {categories.map((category) => (
          <option key={category.id} value={category.id} selected={category.id === selectedCategory?.id}>
            {category.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoryList;
